export var EditState;
(function (EditState) {
    EditState["ACTIVE"] = "ACTIVE";
    EditState["EDITED"] = "EDITED";
    EditState["DEACTIVATED"] = "DEACTIVATED";
    EditState["EDITABLE"] = "EDITABLE";
    EditState["LOCKED"] = "LOCKED";
})(EditState || (EditState = {}));
